{
  "back": "Quay lại",
  "form": "Biểu mẫu",
  "purposeTitle": "Mục đích điểm dừng của bạn là gì?",
  "appointmentInfoTitle": "Thông tin cuộc hẹn",
  "appointmentInfoHint": "Hãy nhớ điền vào trường này nếu bạn có cuộc hẹn.",
  "checkInDetailsTitle": "Chi tiết check-in",
  "checkInDetailsHint": "Thông tin bổ sung về chuyến đến của bạn.",
  "driverPhoneLabel": "Số điện thoại của tài xế",
  "activateWhatsAppTitle": "Kích hoạt nhắn tin WhatsApp",
  "activateWhatsAppBody": "Để trò chuyện với kho hàng, vui lòng trả lời \"OK\" khi chúng tôi gửi cho bạn tin nhắn WhatsApp đầu tiên.",
  "whatsappDelayBanner": "Tin nhắn WhatsApp đầu tiên có thể mất tối đa một phút để đến.",
  "notesLabel": "Ghi chú",
  "notesPlaceholder": "Có hướng dẫn đặc biệt hoặc ghi chú nào cho cơ sở không?",
  "verifyAndCheckIn": "Xác minh và check-in",
  "completeCheckIn": "Hoàn tất check-in",
  "visitGroupInbound": "Nhập hàng",
  "visitGroupOutbound": "Xuất hàng",
  "visitGroupBoth": "Nhập & Xuất hàng",
  "visitUnloadTruck": "Dỡ hàng khỏi xe tải của tôi",
  "visitDropTrailer": "Thả rơ-moóc hoặc container của tôi",
  "visitLoadTruck": "Xếp hàng lên xe tải của tôi",
  "visitHookTrailer": "Móc rơ-moóc hoặc container",
  "visitUnloadLoad": "Dỡ & Xếp hàng cho xe tải của tôi",
  "visitDropHook": "Thả & Móc rơ-moóc hoặc container",
  "containerTrailer": "Rơ-moóc",
  "containerContainer": "Container",
  "containerOversized": "Quá khổ",
  "containerOther": "Khác",
  "defaultReferenceName": "Số PO",
  "identifierSuffix": "{reference} hoặc Số xác nhận",
  "licenseOrDotRequired": "Vui lòng điền Biển số xe hoặc Số DOT",
  "appointmentNotFound": "Chúng tôi không thể tìm thấy cuộc hẹn của bạn",
  "referenceNotFound": "Không tìm thấy cuộc hẹn phù hợp. Số tham chiếu phân biệt chữ hoa chữ thường.",
  "referenceCaseSensitiveHint": "Số tham chiếu phân biệt chữ hoa chữ thường",
  "messaging": {
    "whatsappFailedTitle": "Không thể gửi tin nhắn WhatsApp",
    "smsFailedTitle": "Không thể gửi tin nhắn SMS",
    "whatsappFailedBody": "Chúng tôi không thể gửi tin nhắn đến {displayPhone}. <br /><br /> Nếu trước đây bạn đã hủy đăng ký, vui lòng nhắn START đến <a href='{waUrl}' target='_blank' rel=\"noopener noreferrer\">{senderPhone}</a> để bắt đầu nhận tin nhắn từ kho hàng này.",
    "smsFailedBody": "Chúng tôi không thể gửi tin nhắn đến {displayPhone}. <br /><br /> Nếu trước đây bạn đã hủy đăng ký, vui lòng nhắn START đến <a href='{smsUrl}'>{senderPhone}</a> để bắt đầu nhận tin nhắn SMS từ kho hàng này.",
    "fallbackPhone": "số điện thoại đã cung cấp"
  }
}
